var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66675 6H4.66675",
    stroke: "#17191D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 7.31327V8.68665C14.6667 9.05331 14.3734 9.35328 14.0001 9.36662H12.6934C11.9734 9.36662 11.3134 8.83995 11.2534 8.11995C11.2134 7.69995 11.3734 7.30662 11.6534 7.03328C11.9 6.77995 12.24 6.6333 12.6134 6.6333H14.0001C14.3734 6.64663 14.6667 6.94661 14.6667 7.31327Z",
    stroke: "#17191D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6532 7.03337C11.3732 7.3067 11.2133 7.70004 11.2533 8.12004C11.3133 8.84004 11.9732 9.3667 12.6932 9.3667H13.9999V10.3334C13.9999 12.3334 12.6666 13.6667 10.6666 13.6667H4.66659C2.66659 13.6667 1.33325 12.3334 1.33325 10.3334V5.66671C1.33325 3.85337 2.42659 2.58671 4.12659 2.37337C4.29992 2.34671 4.47992 2.33337 4.66659 2.33337H10.6666C10.8399 2.33337 11.0066 2.34003 11.1666 2.3667C12.8866 2.5667 13.9999 3.84004 13.9999 5.66671V6.63338H12.6132C12.2399 6.63338 11.8999 6.78003 11.6532 7.03337Z",
    stroke: "#17191D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet2);
export default __webpack_public_path__ + "static/media/wallet-2.8a72c5e8f3ee315223b61717b6ede3c0.svg";
export { ForwardRef as ReactComponent };